export const checkAnyValue = (obj: any): boolean => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
      return true;
    }
  }
  return false;
};
